import * as React from 'react';

export const Eye = () => (
  <svg viewBox='0 0 60 46'>
    <path
      d='M57.9 31.3S45.2 44.1 29.5 44.1 1.2 31.3 1.2 31.3s12.7-14.6 28.4-14.6 28.3 14.6 28.3 14.6z'
      fill='none'
      stroke='#F02B4C'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d={`M36.3 30.5c0 3.7-3 6.8-6.8 6.8s-6.8-3-6.8-6.8 3-6.8 6.8-6.8 6.8 3 6.8 6.8zM6.6 \
      19.4L1 12.3M16.5 12.8l-3.6-8.3M52.5 19.4l5.6-7.1M42.6 12.8l3.6-8.3M29.5 10.3V1`}
      fill='none'
      stroke='#F02B4C'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);


// WEBPACK FOOTER //
// src/app/src/components/Icons/Eye.tsx